export default __webpack_public_path__ + "static/media/top_mba.2e5f70e4.svg";